import { render } from "./ListeFamille.vue?vue&type=template&id=01dff12d&ts=true"
import script from "./ListeFamille.vue?vue&type=script&lang=ts"
export * from "./ListeFamille.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__